"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _index = require("../../../../../ModalContents/WithModules/WithModulesForm/Pinned/PinnedContentSection/Form/TopLevelEntityTable/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function useVisibilityHook(_ref) {
  var content = _ref.content,
    entityCompletionMap = _ref.entityCompletionMap,
    isAllComplete = _ref.isAllComplete,
    isAllRequiredComplete = _ref.isAllRequiredComplete,
    language = _ref.language,
    moduleCompletionMap = _ref.moduleCompletionMap,
    surveyCompletionMap = _ref.surveyCompletionMap;
  var isClickable = true;
  var isVisible = true;
  if (content.visibility === 'hidden') {
    isClickable = false;
    isVisible = false;
  } else if (content.visibility === 'disabled' || content.type === 'bookmark') {
    isClickable = false;
  } else {
    // always visible and clickable is default behavior
    return {
      isClickable: isClickable,
      isVisible: isVisible
    };
  }
  var isComplete = false;
  if (content.unlockAfter === 'all') {
    isComplete = isAllComplete;
  } else if (content.unlockAfter === 'allRequired') {
    isComplete = isAllRequiredComplete;
  } else if (content.unlockAfter === 'entity') {
    var entityId = (0, _get2["default"])(content, _index.fieldMap[language], -1);
    isComplete = entityId in entityCompletionMap && entityCompletionMap[entityId];
  } else if (/^module_[0-9]{1,}$/.test(content.unlockAfter)) {
    var moduleId = parseInt(content.unlockAfter.replace(/^module_/, ''), 10);
    isComplete = !Number.isNaN(moduleId) && moduleId in moduleCompletionMap && moduleCompletionMap[moduleId];
  } else if (/^survey_/.test(content.unlockAfter)) {
    var surveyHandle = content.unlockAfter.replace(/^survey_/, '');
    isComplete = surveyHandle in surveyCompletionMap && surveyCompletionMap[surveyHandle];
  }
  if (isComplete) {
    isClickable = true;
    isVisible = true;
  }
  return {
    isClickable: isClickable,
    isVisible: isVisible
  };
}
var _default = exports["default"] = useVisibilityHook;